// UI constants

export const MAX_PAGE_WIDTH = 2150;
export const MAX_CONTENT_WIDTH = 1328;
export const MAX_MD_CONTENT_WIDTH = 1200;
export const MAX_XS_CONTENT_WIDTH = 850;

export const LEFT_MENU_WIDTH = '15vw';
export const LEFT_MENU_WIDTH_MAX = 300;
export const LEFT_MENU_WIDTH_MIN = 250;

export const PAGE_RIGHT_MENU_DESKTOP_WIDTH = 240;

export const maxPadding = '90px';
export const lgDynamicPadding = '4vw';
export const mdDynamicPadding = '3.5vw';
export const smDynamicPadding = '5vw';
export const minPadding = '26px';
